import React, { useState } from "react";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
const placesLibrary = ["places"];

const AddressAuto = ({
  setRentalPickup,
  placeholder,
  setPickupLocation,
  setBookPickUp,
  value,
  setStateCountry,
  setCountry,
  setDrop,
  onChange,
  setPickup,
  setBookDropOff,
}) => {
  const [searchResult, setSearchResult] = useState("Result: none");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.MAPKEY,
    libraries: placesLibrary,
  });

  function onLoad(autocomplete) {
    setSearchResult(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      const place = searchResult.getPlace();
      
      const name = place.name;
      const status = place.business_status;
      const formattedAddress = place.formatted_address;
      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();
      // setPickupLocation(formattedAddress);
      
  //       const pickupObj = {
  //         address: formattedAddress,
  //         lat: lat,
  //         lng: lng,
  //       };
        
  //       setPickup(formattedAddress);
  //       setPickup(pickupObj);
      
  //   } else {
  //     alert("Please enter text");
  //   }
  // }
  if (placeholder === "Search by Destination, Attraction or Activities") {
    const pickupObj = {
      address: formattedAddress,
      lat: lat,
      lng: lng,
    };
    setBookPickUp(formattedAddress);
    setPickup(pickupObj);
  }
  else {
        // alert("Please enter text");
        const dropObj = {
          address: formattedAddress,
          lat: lat,
          lng: lng,
        };
        setStateCountry(formattedAddress);
        setCountry(dropObj);
      }
    }
    else {
      alert("Please enter text");
    }
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <> 
      <div className="searchMenu-loc lg:px-0 js-form-dd js-liverSearch" style={{marginTop:"0px"}}>
        <div className="text-15 text-light-1 ls-2 lh-16 input-style" style={{height:"100%",padding:"15px"}}>
          <div id="searchColumn">
            <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
              <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="js-search js-dd-focus"
              />
            </Autocomplete>
          </div>
        </div>

        {/* min-width-400 */}
      </div>
    </>
  );
};

export default AddressAuto;
